import React from "react"
import { Box, Grid, Typography } from "@mui/material"
import Stack from "@mui/material/Stack"
import logo from "../../../resources/images/Precipart_TxtGray_LeafOrange.png"
import warning from "../../../resources/images/warning.png"
import { gearDepartmentNumbers } from "../../../config"

import { ActualStyles, BaselineStyles, BlankInitStyles, BlankStyles, BluePrintStyles, CertStyles, ControlBlankInitStyles, ControlEvenSpaceSmallStyles, ControlEvenSpaceStyles, ControlMethodStyles, ControlOpInsStyles, CustomerStyles, DateInitStyles, DateStyles, DeptStyles, DWGStyles, EvenSpaceStyles, GearBlankStyles, GearEvenSpaceAlt2Styles, GearEvenSpaceAltStyles, GearEvenSpaceStyles, InProcessStyles, InspectionReportStyles, JobSetupStyles, LogoStyles, MaterialStyles, MethodStyles, NoCertStyles, NoMaterialStyles, OperatorStyles, OpInsStyles, OutlineGridStyles, OutputNameStyles, PageNumberStyles, SectionGearStyles, SectionPartStyles, StampStyles, ToolIdStyles, WarningLabelStyles, WarningStyles } from "./styles/OutputStyles"

function InProcessHeader({ output }) {
    const numDates = [1, 2, 3, 4, 5]

    return (
        <Grid>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
            >
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="flex-start"
                    item
                    size={12}
                >
                    <Grid
                        item
                        container
                        size={2}
                        justifyContent="flex-start"
                        alignItems="center"
                        wrap="nowrap"
                    >
                        <Box
                            component="img"
                            alt="Logo"
                            src={logo}
                            sx={LogoStyles}
                        />
                    </Grid>
                    <Grid item size={8}>
                        <Stack>
                            {output.ppap && (
                                <Typography
                                    
                                    sx={OutputNameStyles}
                                    noWrap
                                    align="center"
                                >
                                    <b>Control Plan</b>
                                </Typography>
                            )}
                            <Typography
                                
                                sx={OutputNameStyles}
                                noWrap
                                align="center"
                            >
                                {`First Piece / In Process / Roving ${
                                    gearDepartmentNumbers.includes(
                                        output.department.trim()
                                    )
                                        ? "(Gear Department)"
                                        : ""
                                }`}
                            </Typography>

                            <Typography
                                
                                sx={InspectionReportStyles}
                                noWrap
                                align="center"
                            >
                                Inspection Report
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item size={2}>
                        {!output.secondVerified ? (
                            <Grid
                                container
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Box
                                    component="img"
                                    alt="Warning"
                                    src={warning}
                                    sx={WarningStyles}
                                />
                                <Typography
                                    
                                    sx={WarningLabelStyles}
                                    align="center"
                                >
                                    First Piece
                                    <br />
                                    Only
                                </Typography>
                            </Grid>
                        ) : (
                            <Typography
                                sx={PageNumberStyles}
                                noWrap
                                align="center"
                            ></Typography>
                        )}
                    </Grid>
                </Grid>
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="flex-start"
                    item
                    size={12}
                >
                    <Grid item size={4}>
                        <Typography
                            
                            sx={CustomerStyles}
                            noWrap
                            align="left"
                        >
                            <strong>Customer: </strong>
                            <u>{output.customer}</u>
                        </Typography>
                    </Grid>
                    <Grid item size={4}>
                        <Typography
                            
                            noWrap
                            align="center"
                            sx={DeptStyles}
                        >
                            <strong>Department / Machine: </strong>
                            <u>
                                {output.department} / {output.machine}
                            </u>
                        </Typography>
                    </Grid>
                    <Grid item size={4}>
                        <Typography
                            
                            noWrap
                            align="right"
                            sx={DeptStyles}
                        >
                            <strong>Approved By : </strong>
                            <u>{output.secondVerifiedBy}</u>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                sx={OutlineGridStyles}
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography
                    
                    sx={SectionPartStyles}
                    noWrap
                    align="left"
                >
                    <strong>Part Number:</strong> <u>{output.partNumber}</u>
                </Typography>
                <Typography
                    
                    sx={SectionPartStyles}
                    noWrap
                    align="left"
                >
                    <strong>Revision:</strong> <u>{output.partRevision}</u>
                </Typography>

                <Typography
                    
                    sx={SectionPartStyles}
                    noWrap
                    align="left"
                >
                    <strong>Part Name:</strong> <u>{output.partName}</u>
                </Typography>
                <Typography
                    
                    sx={SectionPartStyles}
                    noWrap
                    align="left"
                >
                    <strong>Manufacturing Order: </strong>{" "}
                    <u>{output.manufacturingOrder}</u>
                </Typography>
                <Typography
                    
                    sx={SectionPartStyles}
                    noWrap
                    align="left"
                >
                    <strong>Operation: </strong>
                    <u>{output.operation}</u>
                </Typography>
            </Grid>
            {gearDepartmentNumbers.includes(output.department.trim()) ? (
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="stretch"
                >
                    <Grid item sx={GearEvenSpaceStyles}>
                        <Typography
                            
                            sx={SectionGearStyles}
                            noWrap
                            align="left"
                        >
                            <strong>
                                Gear Tester
                                <br />
                                Serial No
                            </strong>
                            <br />
                            <u>Verified</u>
                        </Typography>
                    </Grid>
                    <Grid item sx={GearEvenSpaceAltStyles}>
                        <Typography
                            
                            sx={SectionGearStyles}
                            noWrap
                            align="left"
                        >
                            <strong>
                                Gear
                                <br />
                                Master
                            </strong>
                            <br />
                            <u>Verified</u>
                        </Typography>
                    </Grid>
                    <Grid item sx={GearEvenSpaceAltStyles}>
                        <Typography
                            
                            sx={SectionGearStyles}
                            noWrap
                            align="left"
                        >
                            <strong>
                                Mandrel for
                                <br />
                                Gear
                            </strong>
                            <br />
                            <u>Verified</u>
                        </Typography>
                    </Grid>
                    <Grid item sx={GearEvenSpaceAltStyles}>
                        <Typography
                            
                            sx={SectionGearStyles}
                            noWrap
                            align="left"
                        >
                            <strong>
                                Gage Block
                                <br />
                                Size
                            </strong>
                            <br />
                            <u>Verified</u>
                        </Typography>
                    </Grid>
                    <Grid item sx={GearEvenSpaceAlt2Styles}>
                        <Typography
                            
                            sx={SectionGearStyles}
                            noWrap
                            align="left"
                        >
                            <strong>
                                Number of
                                <br />
                                Teeth
                            </strong>
                            <br />
                            <u>Verified</u>
                        </Typography>
                    </Grid>
                    <Grid item sx={GearEvenSpaceAlt2Styles}>
                         <Typography
                             
                             sx={SectionGearStyles}
                             noWrap
                             align="left"
                         >
                             <strong>
                                 Machine
                                 <br />
                                 No
                             </strong>
                             <br />
                             <u>Verified</u>
                         </Typography>
                     </Grid>
                </Grid>
            ) : null}
            <Grid container justifyContent="flex-start" alignItems="flex-start">
                <Grid item size={5}>
                    <Typography
                        
                        sx={JobSetupStyles}
                        noWrap
                        align="left"
                    >
                        First Piece Results/
                        <br />
                        Job Setup By ____________
                    </Typography>
                </Grid>
                <Grid item size={1}>
                    <Typography
                        
                        sx={
                            gearDepartmentNumbers.includes(
                                output.department.trim()
                            )
                                ? GearBlankStyles
                                : BlankStyles
                        }
                        noWrap
                        align="left"
                    ></Typography>
                </Grid>
                <Grid item size={6}>
                    <Typography
                        
                        sx={InProcessStyles}
                        noWrap
                        align="left"
                    >
                        In Process Results / Roving Inspections
                    </Typography>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="stretch"
            >
                <Grid
                    item
                    size={6}
                    container
                    justifyContent="flex-start"
                    alignItems="stretch"
                >
                    <Grid item size={4}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >
                            <Typography
                                
                                sx={DateStyles}
                                noWrap
                                align="left"
                            >
                                Date:
                            </Typography>
                            <Typography
                                
                                sx={DWGStyles}
                                noWrap
                                align="left"
                            >
                                DWG/Routing Characteristics
                            </Typography>
                            <Typography
                                
                                sx={
                                    output.material
                                        ? MaterialStyles
                                        : NoMaterialStyles
                                }
                                noWrap
                                align="left"
                            >
                                <b>Material: </b>
                                <br />
                                {output.material}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item size={2}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >
                            <Typography
                                
                                sx={StampStyles}
                                noWrap
                                align="left"
                            >
                                Stamp/Initials:
                            </Typography>
                            <Typography
                                
                                sx={ActualStyles}
                                noWrap
                                align="left"
                            >
                                Actual Readings
                            </Typography>
                            <Typography
                                
                                sx={
                                    output.certification
                                        ? CertStyles
                                        : NoCertStyles
                                }
                                noWrap
                                align="left"
                            >
                                <b>Certs.No.</b>
                                <br />
                                {output.certification}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item size={2}>
                        <Typography
                            
                            sx={OperatorStyles}
                            noWrap
                            align="center"
                        >
                            Operator <br /> Inspection <br /> Sample / <br />{" "}
                            Frequency
                        </Typography>
                    </Grid>
                    <Grid item size={2}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >
                            <Typography
                                
                                sx={MethodStyles}
                                noWrap
                                align="center"
                            >
                                Mandatory <br /> Method of <br /> Inspection
                            </Typography>
                            <Typography
                                
                                sx={BaselineStyles}
                                noWrap
                                align="center"
                            >
                                (see baseline <br />
                                for all others)
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item size={1}>
                        <Typography
                            
                            sx={ToolIdStyles}
                            noWrap
                            align="center"
                        >
                            Tool <br /> ID
                        </Typography>
                    </Grid>

                    <Grid item size={1}>
                        {!output.ppap ? (
                            <Typography
                                
                                sx={BluePrintStyles}
                                noWrap
                                align="center"
                            >
                                Blue <br /> Print <br /> Loc
                            </Typography>
                        ) : (
                            <Typography
                                
                                sx={ControlMethodStyles}
                                noWrap
                                align="center"
                            >
                                Control <br /> Method
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    size={6}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="stretch"
                >
                    {!output.ppap ? null : (
                        <>
                            <Grid
                                item
                                sx={ControlEvenSpaceSmallStyles}
                            >
                                <Typography
                                    
                                    sx={ControlMethodStyles}
                                    noWrap
                                    align="center"
                                >
                                    Reaction <br /> Plan
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                sx={ControlEvenSpaceSmallStyles}
                            >
                                <Typography
                                    
                                    sx={BluePrintStyles}
                                    noWrap
                                    align="center"
                                >
                                    Blue <br /> Print <br /> Loc
                                </Typography>
                            </Grid>
                        </>
                    )}
                    {numDates.map((item) => (
                        <Grid
                            item
                            sx={
                                !output.ppap
                                    ? EvenSpaceStyles
                                    : ControlEvenSpaceStyles
                            }
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="stretch"
                            >
                                <Typography
                                    
                                    sx={DateInitStyles}
                                    noWrap
                                    align="left"
                                >
                                    Date:
                                </Typography>
                                <Typography
                                    
                                    sx={
                                        !output.ppap
                                            ? BlankInitStyles
                                            : ControlBlankInitStyles
                                    }
                                    noWrap
                                    align="left"
                                ></Typography>
                                <Typography
                                    
                                    sx={
                                        !output.ppap
                                            ? OpInsStyles
                                            : ControlOpInsStyles
                                    }
                                    noWrap
                                    align="center"
                                >
                                    Actual Readings-
                                    <br />
                                    Operator/Inspector
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default InProcessHeader
